import { createContext } from 'react';
import type { Me } from './roles';

export interface AuthContextValue {
  user: Me | null;
  /** True until the initial /me probe settles — gate routes on it to avoid login flashes. */
  loading: boolean;
  login: (email: string, password: string) => Promise<'done' | 'mfa'>;
  verifyMfa: (code: string, isRecoveryCode?: boolean) => Promise<void>;
  logout: () => Promise<void>;
  /** Re-fetches /me — call after anything that changes role/status/MFA. */
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
